import statesList from 'data/states-list'

export const stateOptions = statesList.map(
  (s: { id: string; name: string; abbreviation: string }) => ({
    value: s.id,
    label: `${s.abbreviation} — ${s.name}`,
  })
)

const stateLabelById = new Map(
  stateOptions.map((o) => [o.value, o.label] as const)
)

export const formatStateLabel = (code?: string): string =>
  (code && stateLabelById.get(code)) || code || '—'
